module.exports = __webpack_public_path__ + "img/credit_card.dcda506b.svg";